import { PCMilerMapWrapper } from "../PCMiler/PCMilerWrapper";
import { ExpandCollapseControl } from "../PCMiler/PCMilerClass";
import { MAX_ZOOM } from "../../utils/constants";

export namespace GeoService {
  /**
   * @readonly Connection between custom Third Party Plugin's wrapper class to MapWrapper below
   * NOTE: Incase of plugin change, Change `MapWrapper` with new one and update replace `TrimbleMaps` types
   */
  export const MapWrapper: any = PCMilerMapWrapper;
  /**
   * @readonly MaxZoomLevel sets the maximum zoom capacity of the map instance
   * MaxZoomLevel enabled when `isLimitedZoom` property is passed as true in renderMap method
   */
  export const MaxZoomLevel: number = MAX_ZOOM;
  /**
   * @readonly Interface which interact with Wrapper class mentioned above
   */
  export interface MapSource {
    renderMap(
      isLimitedZoom: boolean,
      container: Container,
      bounds: Bounds,
      style: string,
      fitBoundsOptions?: FitBoundsOptions
    ): TrimbleMaps.Map;
    createBounds(sw: Sw, ne: Ne): TrimbleMaps.LngLatBounds;
    renderRoute(
      routeId: string,
      stops: Stops,
      frameOptions: FitBoundsOptions
    ): TrimbleMaps.Route;
    renderMarker(
      svgContent: HTMLElement,
      lng: number,
      lat: number
    ): TrimbleMaps.Marker;
    renderPopup(options: PopupOptions): TrimbleMaps.Popup;
    renderFullscreenControl(): TrimbleMaps.FullscreenControl;
    renderExpandCollapseControl(
      isDialog: boolean,
      onExpand: Function,
      onCollapse: Function
    ): ExpandCollapseControl;
    getCoordinates(location: Location): Promise<GeoData[]>;
    getLongitudeLatitude(lng: number, lat: number): Promise<any>;
    destroy(): void;
    navControl(
      options: NavigationControlOptions
    ): TrimbleMaps.NavigationControl;
    getStopMarker(
      stopIndex: number,
      stopsLength: number,
      stopType: string
    ): StopMarker;
    searchCurrentAddress(query: string, getAddress: GetAddressFunction): any;
    searchAddress(query: string, getAddress: GetAddressFunction): any;
  }

  export interface Location {
    city: string;
    state: string;
    postalCode: string | number;
    address: string;
  }
  export interface StopMarker {
    svg: string;
    height: number;
  }
  export type LngLat = { lng: number; lat: number };

  export type Sw = LngLat;
  export type Ne = LngLat;
  export interface PaddingOptions {
    top: number;
    bottom: number;
    left: number;
    right: number;
  }
  export type Container = string | HTMLElement;
  export type Bounds = LngLat | TrimbleMaps.LngLatBounds;
  export interface FitBoundsOptions {
    padding?: number | PaddingOptions;
    maxZoom?: number;
  }

  export type Stops = Array<LngLat>;
  type Anchor =
    | "center"
    | "left"
    | "right"
    | "top"
    | "bottom"
    | "top-left"
    | "top-right"
    | "bottom-left";

  type PointLike = [number, number];
  export type Offset = { [key: string]: PointLike };
  export type PopupOptions = {
    closeButton?: boolean;

    closeOnClick?: boolean;

    /**
     * @param [options.closeOnMove=false] If `true`, the popup will closed when the map moves.
     */
    closeOnMove?: boolean;

    anchor?: Anchor;

    offset?: Offset;

    className?: string;

    maxWidth?: string;
  };

  export interface NavigationControlOptions {
    showCompass?: boolean;
    showZoom?: boolean;
    visualizePitch?: boolean;
  }

  export type GetAddressFunction = (location: SinglesearchLocation[]) => void;

  export interface GeoData {
    Address: Address | null;
    Coords: Coords | null;
    Region: number;
    Label: string | null;
    PlaceName: string | null;
    TimeZone: string | null;
    Errors: Error[];
    SpeedLimitInfo?: any | null;
    ConfidenceLevel: string | null;
    DistanceFromRoad?: any | null;
    CrossStreet: any | null;
  }

  interface Error {
    Type: number;
    Code: number;
    LegacyErrorCode: number;
    Description: string;
  }

  interface Coords {
    Lat: string;
    Lon: string;
  }

  interface Address {
    StreetAddress: string;
    City: string;
    State: string;
    Zip: string;
    County: string;
    Country: string;
    SPLC: string | null;
    CountryPostalFilter: number;
    AbbreviationFormat: number;
    StateName: string;
    StateAbbreviation: string;
    CountryAbbreviation: string;
  }

  export interface SinglesearchLocation {
    Address: {
      StreetAddress: string;
      City: string;
      State: string;
      StateName: string;
      Zip: string;
      County: string;
      Country: string;
      CountryFullName: string;
      SPLC: string | null;
    } | null;
    Coords: Coords | null;
    Region: number;
    POITypeID: number;
    PersistentPOIID: number;
    SiteID: number;
    ResultType: number;
    ShortString: string;
    TimeZone: string;
  }
}
